<template>
  <div id="platform-overview" class="default-layout">

    <header>
      <nav id="navbar">
          <div class="nav">
              <router-link to="/partnership" class="nav-item">Back</router-link>
              <router-link to="/home" class="nav-item">Home</router-link>
          </div>
          <div class="logo">
              <img src="@/assets/images/navbar-logo.svg" alt=""/>
          </div>
      </nav>
    </header>
    
    <main>
      <div class="page-header">
        <p class="eyebrow">Technician Dashboard</p>
        <h1>Platform <br/> Overview</h1>
        <img src="@/assets/images/noc-hero.jpg" alt="" class="mt-12 rounded"/>
      </div>

      <section>
        <PlatformFeaturesList/>
      </section>

      <section>
        <img src="@/assets/images/noc-user-map.jpg" alt="" class="rounded"/>
        <img src="@/assets/images/noc-user.jpg" alt="" class="my-4 rounded"/>
      </section>

    </main>

    <Footer/>
    
  </div>
</template>

<style lang="scss" scoped>



</style>

<script>
    import Footer from '@/components/Footer.vue'
    import PlatformFeaturesList from '@/components/PlatformFeaturesList.vue'
    
    export default {
        components: {
            Footer,
            PlatformFeaturesList
        }
    }
</script>